// SPDX-FileCopyrightText: 2024 Comcast
//
// SPDX-License-Identifier: LicenseRef-Comcast

export class SendAutoGreetingMessage {
  uui: string;
  contextText: string;
}
